import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors'
import * as background from '../../config/backgroundColor'
import * as legend from '../../config/legend'
import * as series from '../../config/series'
import * as toolbox from '../../config/toolbox'
import * as tooltip from '../../config/tootip'
import * as xAxis from '../../config/xAxis'
import * as yAxis from '../../config/yAxis'
import * as brush from '../../config/brush';
import * as textStyle from '../../config/textStyle'
import { CommonService } from '../../service/common.service';
import { axisLabelRotate, legendPosition } from './double-yaxis-bar-interface';

@Injectable({
  providedIn: 'root'
})
export class DoubleYaxisBarService {

  constructor(
    private commonService: CommonService
  ) { }

  // 获取柱状图默认option
  getColumnChartDefaultOption() {
    let style = this.commonService.changeFontSize();
    let option = {
      backgroundColor: background.backgroundColor,
      color: color.defaultColors,
      grid: style.interval,
      legend: legend.getLegendBottomScroll(style),
      // toolbox: toolbox.getToolboxBasicMenu(),
      tooltip: tooltip.getCommonTooltipOfAxis(),
      xAxis: xAxis.getCategoryXAxis(style),
      yAxis: yAxis.getDoubleValueYAxis(style),
      series: series.getDoubleYaxisColumnChartSeries(style),
      textStyle: textStyle.getTextStyle()
    }
    return option;
  }

  changeLegendPosition(chartOption, position: legendPosition) {
    let style = this.commonService.changeFontSize();
    switch (position) {
      case 'none':
        chartOption.legend = legend.getLegendNotShow(style)
        chartOption.grid = style.withoutLegendGrid;
        break;
      case 'top':
        chartOption.legend = legend.getLegendNotShow(style)
        chartOption.grid = style.interval
        break;
      case 'bottom':
        chartOption.legend = legend.getLegendBottomScroll(style)
        chartOption.grid = style.interval
        break;
      case 'right':
        chartOption.legend = legend.getLegendRightScroll(style)
        chartOption.grid = style.rightLegendGrid
        break;
    }
  }

  changeToolboxShow(chartOption, bcacToolboxShow: boolean) {
    // chartOption.toolbox.show = bcacToolboxShow;
  }

  // 更改XAxisName
  changeXAxisName(chartOpt, xAxisName: string) {
    chartOpt.xAxis[0].name = xAxisName;
  }

  // 更改yAxisName
  changeYAxisName(chartOpt, yAxisName: string[]) {
    chartOpt.yAxis[0].name = yAxisName[0];
    chartOpt.yAxis[1].name = yAxisName[1];
  }

  // 更改yAxisNameGap
  changeYAxisNameGap(chartOpt, yAxisNameGap: number) {
    chartOpt.yAxis[0].nameGap = yAxisNameGap;
    chartOpt.yAxis[1].nameGap = yAxisNameGap;
  }

  // x轴label的旋转
  changeXAxisLabelRotate(chartOpt, xAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.xAxis[0].axisLabel.rotate = rotate;
    chartOpt.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }

  // y轴label的旋转
  changeYAxisLabelRotate(chartOpt, yAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (yAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.yAxis.forEach(element => {
      element.axisLabel.rotate = rotate;
      element.axisLabel.formatter = (value: string): string => {
        let valueText = '';
        if (value.length > 5) {
          valueText = value.substring(0, 5) + '...'
        } else {
          valueText = value
        }
        return valueText;
      }
    });
  }

  setInterval(chartOpt, interval: number) {
    chartOpt.xAxis[0].axisLabel.interval = interval;
  }

  // 顶部图例改变
  topLegendChange(legendData: any, chartInstance) {
    legendData.forEach(e => {
      if (e.checked) {
        chartInstance.dispatchAction({
          type: "legendSelect",
          name: e.value
        })
      } else {
        chartInstance.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        })
      }
    })
  }
  // 开启简单Y轴模式
  openSimplifyYAxis(chartOption) {
    let style = this.commonService.changeFontSize();
    let tempAxis = yAxis.getSimplifyYAxisOfValue(style);

    chartOption.yAxis.forEach(element => {
      element.min = tempAxis.min;
      element.max = tempAxis.max;
      element.interval = tempAxis.interval;
    });
  }

  // 更改数据
  changeChartData(chartOpt, data) {
    let style = this.commonService.changeFontSize();
    if (data) {
      chartOpt.xAxis[0].data = data.xData;
    }
    chartOpt.series = series.getDoubleYaxisColumnChartSeries(style, data);

  }
  // 更改tooltip单位
  changeTooltipUnit(chartOpt, tooltipUnit) {
  }

  changeYAxisMinInterval(chartOpt, minInterval: number[]) {
    if (Array.isArray(minInterval)) {
      for (let i = 0; i < minInterval.length; i++) {
        chartOpt.yAxis[i].minInterval = minInterval[i];
      }
    }
  }

  setYAxisMin(chartOpt, yAxisMin: number[]) {
    if (Array.isArray(chartOpt.yAxis)) {
      chartOpt.yAxis.forEach((element, index) => {
        element.min = yAxisMin[index];
      });

    }
  }

  setYAxisMax(chartOpt, yAxisMax: number[]) {
    if (Array.isArray(chartOpt.yAxis)) {
      chartOpt.yAxis.forEach((element, index) => {
        element.max = yAxisMax[index]
      })
    }
  }

  setYAxisInterval(chartOpt, yAxisInterval: number[]) {
    if (Array.isArray(chartOpt.yAxis)) {
      chartOpt.yAxis.forEach((element, index) => {
        element.interval = yAxisInterval[index]
      });
    }
  }
}
